import {assertAndContinue} from 'Asserts';
import {DeprecatedDataFrame, DeprecatedDataFrameColumnDef} from 'data-frames/DataFrameTypes';

import hasColumn from './hasColumn';

/**
 * @deprecated This function is implemented with an old version of the DataFrame interface. New uses are discouraged,
 * instead the function should be converted to use the new interface.
 */
// TODO(BNCH-24546): Remove or reimplement data frame utils that use DeprecatedDataFrame
export default function addColumn<
  TDataRow extends object,
  NewColumnName extends string,
  NewDataRow extends TDataRow & {[key in NewColumnName]: unknown},
>(
  dataFrame: DeprecatedDataFrame<TDataRow>,
  newColumn: DeprecatedDataFrameColumnDef<Pick<NewDataRow, NewColumnName>>,
  generateColumn: (dataRow: TDataRow, index: number) => unknown
): DeprecatedDataFrame<NewDataRow> {
  const {name, type} = newColumn;
  assertAndContinue(
    !hasColumn(dataFrame, name),
    `Expected column "${name}" to not already exist in the dataFrame`
  );

  return {
    ...dataFrame,
    axisTypes: {
      ...dataFrame.axisTypes,
      [name]: type,
    },
    points: dataFrame.points.map((dataRow, index) => ({
      ...dataRow,
      [name]: generateColumn(dataRow, index),
    })),
    // Type assertion needed because TypeScript cannot correctly infer that name is anything but a string even
    // if it's the desired key for the output when doing this style of assignment
  } as DeprecatedDataFrame<NewDataRow>;
}
